import type { MainScore } from "src/api/client-api/olapScores/olapScoresSchema";
import { getRemoteErrorStatus } from "src/api/remoteCollectionState";

export type ScoreDetailRemoteState =
    | { status: "loading" }
    | { status: "success-value" }
    | { status: "success-unavailable" }
    | { status: "empty" }
    | { status: "not-found" }
    | { status: "forbidden" }
    | { status: "contract-error" }
    | { status: "server-error" };

type ScoreDetailRemoteStateInput = {
    score: MainScore | undefined;
    isLoading: boolean;
    error: unknown;
};

export const getScoreDetailRemoteState = (input: ScoreDetailRemoteStateInput): ScoreDetailRemoteState => {
    const { score, isLoading, error } = input;

    if (isLoading) return { status: "loading" };

    if (error !== null && error !== undefined) return { status: getRemoteErrorStatus(error) };
    if (score === undefined) return { status: "empty" };
    if (typeof score.score.value === "number") return { status: "success-value" };

    return { status: "success-unavailable" };
};
